import React from 'react';
import { motion } from 'framer-motion';

const SocialProofBar = () => {
  const logos = [
    'Forbes', 'Entrepreneur', 'Foundr', 'HubSpot', 'Calendly'
  ];

  return (
    <section className="bg-gray-50 py-8">
      <div className="container mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center"
        >
          <p className="text-sm font-semibold text-gray-600 mb-6">
            AS FEATURED IN FORBES & TRUSTED BY 6-FIGURE COACHES
          </p>
          
          <div className="flex flex-wrap justify-center items-center gap-8 lg:gap-12">
            {logos.map((logo, index) => (
              <motion.div
                key={logo}
                initial={{ opacity: 0, scale: 0.8 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="text-gray-400 font-bold text-lg lg:text-xl"
              >
                {logo}
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default SocialProofBar;